import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/histor_price_icon.png'
import _imports_1 from '@/assets/img/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-984565e2")

_pushScopeId("data-v-984565e2")
const _hoisted_1 = { class: "flex flexSb alignC mar-b-20" }
const _hoisted_2 = { class: "c-red f-16" }
const _hoisted_3 = { class: "offer-column flex" }
const _hoisted_4 = { class: "bg-f2 flex-1 text-center" }
const _hoisted_5 = { class: "w-500" }
const _hoisted_6 = { class: "flex-1 text-center " }
const _hoisted_7 = { class: "f-14 c-30 " }
const _hoisted_8 = { class: "offer-order" }
const _hoisted_9 = { class: "offer-nav border-b-e4 flex" }
const _hoisted_10 = { class: "order-detail" }
const _hoisted_11 = {
  key: 0,
  class: "order-offer"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "relative mar-r-8" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "添加", -1)
const _hoisted_14 = { class: "order-car" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "order-car" }
const _hoisted_19 = { class: "order-user-info" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "提交绑定", -1)
const _hoisted_22 = {
  key: 1,
  class: "w-500 c-red mar-b-10"
}
const _hoisted_23 = {
  key: 2,
  class: "c-90 w-500"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "mar-l-70" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "c-00 w-500" }, "提交", -1)
const _hoisted_27 = { class: "mar-l-70" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "text-right width-100" }, "会员号：", -1)
const _hoisted_29 = { class: "mar-l-70 mar-t-12" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", { class: "text-right width-100" }, "会员等级：", -1)
const _hoisted_31 = { class: "mar-l-70 mar-t-12" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { class: "text-right width-100" }, "狼豆余额：", -1)
const _hoisted_33 = { class: "mar-l-70 mar-t-12" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { class: "text-right width-100" }, "钱包余额：", -1)
const _hoisted_35 = { class: "mar-l-70 mar-t-12" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", { class: "text-right width-100" }, "套餐：", -1)
const _hoisted_37 = { class: "mar-l-70 mar-t-12" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { class: "text-right width-100" }, "优惠券：", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "f-12 c-777 mar-t-12" }, "温馨提示： 如需解除绑定，需车主登录会员端 “我的爱车” 模块中删除该车辆。", -1)
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { class: "flex alignC mar-b-10" }
const _hoisted_42 = { class: "mar-r-10" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "w-500" }, "取消绑定", -1)
const _hoisted_44 = {
  key: 0,
  class: "c-90 w-500"
}
const _hoisted_45 = { class: "pay-info" }
const _hoisted_46 = { class: "c-30" }
const _hoisted_47 = { class: "c-30" }
const _hoisted_48 = { class: "c-30" }
const _hoisted_49 = { class: "c-30" }
const _hoisted_50 = { class: "offer-back flex flexSb alignC bg-ff" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "f-16 c-00" }, "维修项目：", -1)
const _hoisted_52 = { class: "mar-r-20 f-22 c-red" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "f-16 c-00" }, "配件：", -1)
const _hoisted_54 = { class: "mar-r-20 f-22 c-red" }
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "f-16 c-00" }, "合计：", -1)
const _hoisted_56 = { class: "mar-r-20 f-22 c-red" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "确定", -1)
const _hoisted_58 = { class: "dialog-content" }
const _hoisted_59 = { class: "dialog-nav flex" }
const _hoisted_60 = { class: "flex dialog-screen" }
const _hoisted_61 = { class: "c-ff" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_63 = { class: "f-12" }
const _hoisted_64 = { class: "c-red f-12" }
const _hoisted_65 = { class: "f-12" }
const _hoisted_66 = { class: "flex flexC form-button" }
const _hoisted_67 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "立即创建", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "c-60 w-500" }, "取 消", -1)
const _hoisted_69 = { class: "f-12" }
const _hoisted_70 = { class: "c-red f-12" }
const _hoisted_71 = { class: "f-12" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_73 = { class: "dialog-content" }
const _hoisted_74 = { class: "dialog-nav flex" }
const _hoisted_75 = { class: "flex dialog-screen" }
const _hoisted_76 = { class: "c-ff" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_78 = { class: "flex flexC form-button" }
const _hoisted_79 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "立即创建", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "c-60 w-500" }, "取 消", -1)
const _hoisted_81 = { class: "border-b-e4 flex flexSb mar-b-16" }
const _hoisted_82 = { class: "flex" }
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "确认", -1)
const _hoisted_84 = { class: "dialog-content" }
const _hoisted_85 = { class: "dialog-nav flex" }
const _hoisted_86 = { class: "mar-r-18" }
const _hoisted_87 = { class: "mar-r-18" }
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { class: "c-ff w-500" }, "确认", -1)
const _hoisted_89 = { class: "flex flexC alignC" }
const _hoisted_90 = /*#__PURE__*/_createVNode("span", { class: "c-30 mar-r-8" }, "车牌", -1)
const _hoisted_91 = /*#__PURE__*/_createVNode("span", { class: "arrow" }, [
  /*#__PURE__*/_createVNode("i")
], -1)
const _hoisted_92 = { class: "city-select absolute bg-ff" }
const _hoisted_93 = { class: "flex flexSb alignC mar-b-16" }
const _hoisted_94 = { class: "flex" }
const _hoisted_95 = {
  key: 0,
  class: "select-city-text mar-r-18 text-center"
}
const _hoisted_96 = {
  key: 0,
  class: "flex"
}
const _hoisted_97 = {
  key: 1,
  class: "flex"
}
const _hoisted_98 = /*#__PURE__*/_createTextVNode("不限制车牌格式")
const _hoisted_99 = { key: 0 }
const _hoisted_100 = {
  key: 0,
  class: "flex flexC alignC bg-f2 add-car mar-t-12"
}
const _hoisted_101 = { class: "w-500" }
const _hoisted_102 = /*#__PURE__*/_createVNode("div", { class: "w-500 c-red mar-l-2" }, "点击查看", -1)
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { class: "w-500" }
const _hoisted_105 = {
  key: 2,
  class: "add-car flex flexC bg-f2 mar-t-12"
}
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "mar-r-18 c-30 w-500" }, "该车牌暂无车辆信息，请添加车辆", -1)
const _hoisted_107 = {
  key: 1,
  style: {"width":"400px","margin":"0 auto","padding":"30px 0"}
}
const _hoisted_108 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增", -1)
const _hoisted_109 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "返回", -1)
const _hoisted_110 = { class: "padding-tb-20 flex flexC alignC bg-f4" }
const _hoisted_111 = { class: "mar-l-16" }
const _hoisted_112 = { class: "mar-l-16" }
const _hoisted_113 = { class: "flex flexC alignC" }
const _hoisted_114 = /*#__PURE__*/_createVNode("span", { class: "c-30 mar-r-8" }, "车牌号码", -1)
const _hoisted_115 = /*#__PURE__*/_createVNode("span", { class: "arrow" }, [
  /*#__PURE__*/_createVNode("i")
], -1)
const _hoisted_116 = { class: "city-select absolute bg-ff" }
const _hoisted_117 = { class: "flex flexSb alignC mar-b-16" }
const _hoisted_118 = { class: "flex" }
const _hoisted_119 = {
  key: 0,
  class: "select-city-text mar-r-18 text-center"
}
const _hoisted_120 = {
  key: 0,
  class: "flex"
}
const _hoisted_121 = {
  key: 1,
  class: "flex"
}
const _hoisted_122 = { key: 0 }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "w-500" }
const _hoisted_125 = { class: "flex flexC alignC add-car mar-t-12" }
const _hoisted_126 = /*#__PURE__*/_createVNode("div", { class: "mar-r-18 c-30 w-500" }, "请选择以上车辆，或为该车牌添加新的车辆", -1)
const _hoisted_127 = {
  key: 1,
  class: "add-car flex flexC bg-f2 mar-t-12"
}
const _hoisted_128 = /*#__PURE__*/_createVNode("div", { class: "mar-r-18 c-30 w-500" }, "该车牌暂无车辆信息，请添加车辆", -1)
const _hoisted_129 = {
  key: 1,
  style: {"width":"400px","margin":"0 auto","padding":"30px 0"}
}
const _hoisted_130 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确认更换", -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("span", { class: "c-60" }, "返回", -1)
const _hoisted_132 = { class: "print" }
const _hoisted_133 = { class: "header" }
const _hoisted_134 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_135 = { class: "store_name" }
const _hoisted_136 = /*#__PURE__*/_createVNode("div", { class: "title flex-1" }, " 车辆维修工时配件报价单 ", -1)
const _hoisted_137 = { class: "body" }
const _hoisted_138 = { class: "order-head flex alignC" }
const _hoisted_139 = { class: "ordersn flex-1" }
const _hoisted_140 = { class: "time" }
const _hoisted_141 = { class: "order-info" }
const _hoisted_142 = /*#__PURE__*/_createVNode("th", null, "车牌号码：", -1)
const _hoisted_143 = /*#__PURE__*/_createVNode("th", null, "车型：", -1)
const _hoisted_144 = /*#__PURE__*/_createVNode("th", null, "车架号：", -1)
const _hoisted_145 = /*#__PURE__*/_createVNode("th", null, "送修人；", -1)
const _hoisted_146 = /*#__PURE__*/_createVNode("th", null, "联系电话：", -1)
const _hoisted_147 = /*#__PURE__*/_createVNode("th", null, "服务类型：", -1)
const _hoisted_148 = /*#__PURE__*/_createVNode("th", null, "进场时间：", -1)
const _hoisted_149 = /*#__PURE__*/_createVNode("th", null, "进场里程：", -1)
const _hoisted_150 = /*#__PURE__*/_createVNode("th", null, "接车人：", -1)
const _hoisted_151 = {
  key: 0,
  class: "project-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_152 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "维修项目"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_153 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_154 = {
  colspan: "4",
  class: "count"
}
const _hoisted_155 = {
  key: 1,
  class: "parts-table",
  border: "1",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_156 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "序号"),
    /*#__PURE__*/_createVNode("th", { width: "50%" }, "配件名称"),
    /*#__PURE__*/_createVNode("th", { width: "10%" }, "数量"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "单价"),
    /*#__PURE__*/_createVNode("th", { width: "15%" }, "金额")
  ])
], -1)
const _hoisted_157 = {
  colspan: "5",
  class: "count"
}
const _hoisted_158 = {
  colspan: "5",
  class: "total"
}
const _hoisted_159 = { class: "other" }
const _hoisted_160 = { class: "info" }
const _hoisted_161 = { class: "item" }
const _hoisted_162 = { class: "item" }
const _hoisted_163 = {
  key: 0,
  class: "store"
}
const _hoisted_164 = /*#__PURE__*/_createVNode("div", { class: "name" }, " 微信扫码支付 ", -1)
const _hoisted_165 = /*#__PURE__*/_createVNode("div", { class: "qrcode" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "{{qrcodeImgeUrl}}",
    alt: ""
  })
], -1)
const _hoisted_166 = { class: "footer" }
const _hoisted_167 = { class: "address" }
const _hoisted_168 = { class: "telphone" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_PrintForm = _resolveComponent("PrintForm")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "bg-ff content",
      style: _ctx.isPrint?'padding-bottom:180px;':''
    }, [
      (_ctx.orderDetail.order)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_1, [
              _createVNode("p", _hoisted_2, " 工单号：" + _toDisplayString(_ctx.orderDetail.ordersn) + " 【" + _toDisplayString(_ctx.orderDetail.orderstatustext) + "】 ", 1)
            ]),
            _createVNode("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carColumn, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "flex",
                  key: index
                }, [
                  _createVNode("p", _hoisted_4, [
                    _createVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
                  ]),
                  _createVNode("p", _hoisted_6, [
                    _createVNode("span", _hoisted_7, _toDisplayString(_ctx.orderDetail[item.prop]), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderNav, (item, index) => {
                  return (_openBlock(), _createBlock("p", {
                    key: index,
                    class: ["mar-r-20 w-500", {'c-red nav-range': _ctx.orderNavIndex == index,}],
                    onClick: ($event: any) => (_ctx.orderNavIndex = index)
                  }, _toDisplayString(item), 11, ["onClick"]))
                }), 128))
              ]),
              _withDirectives(_createVNode("div", _hoisted_10, [
                _createVNode(_component_el_form, {
                  model: _ctx.orderDetail.order.order_receiving_car,
                  "status-icon": "",
                  rules: _ctx.rules,
                  ref: "receivingCar",
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: "进厂里程",
                      prop: "mitplant"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "detail-input",
                          type: "text",
                          disabled: _ctx.orderstatus>3,
                          modelValue: 
                                    _ctx.orderDetail.order.order_receiving_car
                                        .mitplant
                                ,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
                                    _ctx.orderDetail.order.order_receiving_car
                                        .mitplant
                                 = $event)),
                          placeholder: "请输入进厂里程",
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (
                                    _ctx.editReceivingCar(
                                        $event,
                                        1,
                                        'mitplant'
                                    )
                                ))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "油表油量",
                      prop: "ogoquantity"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.orderDetail.order.order_receiving_car.ogoquantity,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.orderDetail.order.order_receiving_car.ogoquantity = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editReceivingCar($event, 1, 'ogoquantity'))),
                          placeholder: "请选择",
                          clearable: "",
                          disabled: _ctx.orderstatus>3
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ogoquantityList, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "预计交车",
                      prop: "edtime_text"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          style: {"width":"278px"},
                          modelValue: 
                                    _ctx.orderDetail.order.order_receiving_car.edtime_text
                                ,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
                                    _ctx.orderDetail.order.order_receiving_car.edtime_text
                                 = $event)),
                          type: "datetime",
                          placeholder: "请选择交车时间",
                          disabled: _ctx.orderstatus>3,
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editReceivingCar($event, 1, 'edtime')))
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "服务描述",
                      prop: "maintenance"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          class: "detail-input",
                          disabled: _ctx.orderstatus>3,
                          modelValue: 
                                    _ctx.orderDetail.order.order_receiving_car
                                        .maintenance
                                ,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (
                                    _ctx.orderDetail.order.order_receiving_car
                                        .maintenance
                                 = $event)),
                          placeholder: "请输入服务描述",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (
                                    _ctx.editReceivingCar($event, 1, 'maintenance')
                                ))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ], 512), [
                [_directive_loading, _ctx.orderDetailLoading[0]],
                [_vShow, _ctx.orderNavIndex == 0]
              ]),
              (_ctx.orderDetail.offer)
                ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_11, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.offer, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode(_component_el_table, {
                          data: item,
                          stripe: "",
                          style: {"width":"100%"},
                          "header-cell-style": _ctx.headClass
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              label: "",
                              align: "center",
                              "min-width": "48"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("div", {
                                  class: "delete-offer bg-red relative",
                                  onClick: ($event: any) => (_ctx.deleteOffer(scope.row.id))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            (index == 0)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  label: "服务项目",
                                  prop: "project_name",
                                  align: "center",
                                  "min-width": "355"
                                }))
                              : _createCommentVNode("", true),
                            (index == 1)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 1,
                                  label: "配件",
                                  prop: "mountings_name",
                                  align: "center",
                                  "min-width": "355"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_table_column, {
                              label: "参考价",
                              prop: "reference_price",
                              align: "center",
                              "min-width": "106"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "报价",
                              prop: "quoted_price",
                              align: "center",
                              "min-width": "120"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  modelValue: scope.row['quoted_price'],
                                  "onUpdate:modelValue": ($event: any) => (scope.row['quoted_price'] = $event),
                                  placeholder: "请输入",
                                  onChange: ($event: any) => (
                                            _ctx.quotedPriceChange(scope.row, index)
                                        )
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_table_column, {
                              label: "历史报价",
                              align: "center",
                              "min-width": "106"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("img", {
                                  onClick: ($event: any) => (_ctx.selectHistor(scope.row)),
                                  src: _imports_0,
                                  class: "histor-icon"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "数量",
                              prop: "num",
                              align: "center",
                              "min-width": "106"
                            }, _createSlots({ _: 2 }, [
                              (index==1)
                                ? {
                                    name: "default",
                                    fn: _withId((scope) => [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        modelValue: scope.row['num'],
                                        "onUpdate:modelValue": ($event: any) => (scope.row['num'] = $event),
                                        placeholder: "请输入",
                                        onChange: ($event: any) => (_ctx.mountingsNumberChange(scope.row, index))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ])
                                  }
                                : undefined
                            ]), 1024),
                            _createVNode(_component_el_table_column, {
                              label: "销售人",
                              align: "center",
                              "min-width": "106"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_button, {
                                  onClick: ($event: any) => (_ctx.choiceSalesman(scope.row))
                                }, {
                                  default: _withId(() => [
                                    _createVNode("p", null, _toDisplayString(scope.row["salesman_name"]), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "施工人",
                              align: "center",
                              "min-width": "150"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_button, {
                                  onClick: ($event: any) => (_ctx.choiceBuilders(scope.row))
                                }, {
                                  default: _withId(() => [
                                    _createVNode("p", null, _toDisplayString(scope.row["builders_name"]), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["data", "header-cell-style"]),
                        _createVNode("div", {
                          class: "add flex flexC alignC",
                          onClick: ($event: any) => (_ctx.addOffer(index))
                        }, [
                          _hoisted_12,
                          _hoisted_13
                        ], 8, ["onClick"])
                      ]))
                    }), 128))
                  ], 512)), [
                    [_directive_loading, _ctx.orderDetailLoading[1]],
                    [_vShow, _ctx.orderNavIndex == 1]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode("div", _hoisted_14, [
                _createVNode(_component_el_form, {
                  model: _ctx.orderDetail.order.order_car,
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_el_form_item, { label: "VIN" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.vin
                                        ,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.vin
                                         = $event)),
                              placeholder: "请输入VIN",
                              disabled: _ctx.orderstatus>3,
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "所属单位" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              class: "mar-r-8 detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.units_id
                                        ,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.units_id
                                         = $event)),
                              placeholder: "请选择",
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.repairunit_data, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.repair_unit_name,
                                    value: item.repair_unit_id,
                                    key: item.repair_unit_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "车主姓名" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .master_name
                                        ,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .master_name
                                         = $event)),
                              placeholder: "请输入车主姓名",
                              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "车主身份证" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.idcard
                                        ,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.idcard
                                         = $event)),
                              placeholder: "请输入车主身份证",
                              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "下次保养" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"278px"},
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.nm_time_text
                                        ,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.nm_time_text
                                         = $event)),
                              placeholder: "请选择下次保养时间",
                              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.saveCarInfoChange($event,'nmtime')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "年检到期" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"278px"},
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.aidue_text
                                        ,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.aidue_text
                                         = $event)),
                              placeholder: "请选择年检到期时间",
                              onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.saveCarInfoChange($event,'aidue')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "商业险到期" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"278px"},
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.ccidue_text
                                        ,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.ccidue_text
                                         = $event)),
                              placeholder: "请选择商业险到期时间",
                              onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.saveCarInfoChange($event,'ccidue')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "商业险公司" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              class: "mar-r-8 detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .cicompany_id
                                        ,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .cicompany_id
                                         = $event)),
                              placeholder: "请选择",
                              onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.name,
                                    value: item.id,
                                    key: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "商业险保单号" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .cipnumber
                                        ,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .cipnumber
                                         = $event)),
                              placeholder: "请输入商业险保单号",
                              onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", _hoisted_17, [
                        _createVNode(_component_el_form_item, { label: "品牌车型" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              class: "mar-r-8",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .car_brand_id
                                        ,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .car_brand_id
                                         = $event)),
                              style: {"width":"108px"},
                              filterable: "",
                              placeholder: "请选择",
                              onChange: _cache[28] || (_cache[28] = ($event: any) => (
                                            _ctx.DetailselectChange(
                                                $event,
                                                'car_brand_id'
                                            )
                                        ))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_brand_data, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.brand_name,
                                    value: item.id,
                                    key: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"]),
                            _createVNode(_component_el_select, {
                              class: "mar-r-18",
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .car_series_id
                                        ,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .car_series_id
                                         = $event)),
                              placeholder: "请选择",
                              style: {"width":"132px"},
                              disabled: 
                                            !_ctx.orderDetail.order.order_car
                                                .car_brand_id || _ctx.orderstatus>3
                                        ,
                              onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_series_data, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.series_name,
                                    value: item.id,
                                    key: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "车身颜色" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .body_color
                                        ,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .body_color
                                         = $event)),
                              placeholder: "请输入车身颜色",
                              onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "车主手机" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .car_master_phone
                                        ,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .car_master_phone
                                         = $event)),
                              placeholder: "请输入车主手机",
                              onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "发动机号" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .engine_number
                                        ,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .engine_number
                                         = $event)),
                              placeholder: "请输入发动机号",
                              onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "保养里程" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .maintenance_mileage
                                        ,
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .maintenance_mileage
                                         = $event)),
                              placeholder: "请输入保养里程",
                              onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "购车时间" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"278px"},
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .purchase_time_text
                                        ,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .purchase_time_text
                                         = $event)),
                              placeholder: "请选择购车时间",
                              onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.saveCarInfoChange($event,'purchase_time')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "交强险到期" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"278px"},
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car.compulsory_insurance_due_text
                                        ,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car.compulsory_insurance_due_text
                                         = $event)),
                              placeholder: "请选择交强险到期时间",
                              onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.saveCarInfoChange($event,'compulsory_insurance_due')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "交强险公司" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              class: "mar-r-8 detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .jicompany_id
                                        ,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .jicompany_id
                                         = $event)),
                              placeholder: "请选择",
                              onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.name,
                                    value: item.id,
                                    key: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "交强险保单号" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              class: "detail-input",
                              disabled: _ctx.orderstatus>3,
                              modelValue: 
                                            _ctx.orderDetail.order.order_car
                                                .dipolicy_no
                                        ,
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (
                                            _ctx.orderDetail.order.order_car
                                                .dipolicy_no
                                         = $event)),
                              placeholder: "请输入交强险保单号",
                              onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                            }, null, 8, ["disabled", "modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_el_form_item, { label: "接车提示" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          disabled: _ctx.orderstatus>3,
                          modelValue: 
                                    _ctx.orderDetail.order.order_car
                                        .tips
                                ,
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (
                                    _ctx.orderDetail.order.order_car
                                        .tips
                                 = $event)),
                          placeholder: "请输入接车提示",
                          onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.saveCarInfoChange($event,'tips')))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ], 512), [
                [_directive_loading, _ctx.orderDetailLoading[0]],
                [_vShow, _ctx.orderNavIndex == 2]
              ]),
              _withDirectives(_createVNode("div", _hoisted_18, [
                _createVNode("div", null, [
                  _createVNode(_component_el_form, {
                    model: _ctx.orderDetail,
                    ref: "formRef",
                    "label-position": "left",
                    "label-width": "100px",
                    class: "mar-b-20 check"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "服务类型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            class: "detail-input",
                            disabled: _ctx.orderstatus>3,
                            modelValue: 
                                        _ctx.orderDetail.order.order_message
                                            .service_type_id
                                    ,
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (
                                        _ctx.orderDetail.order.order_message
                                            .service_type_id
                                     = $event)),
                            placeholder: "请选择",
                            onChange: _cache[50] || (_cache[50] = ($event: any) => (
                                        _ctx.editReceivingCar(
                                            $event,
                                            3,
                                            'service_type_id'
                                        )
                                    ))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_data, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.basicset_name,
                                  value: item.basicset_id,
                                  key: item.basicset_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "送修人" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            disabled: _ctx.orderstatus>3,
                            class: "detail-input",
                            modelValue: 
                                        _ctx.orderDetail.order.order_message
                                            .send_for_repair
                                    ,
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (
                                        _ctx.orderDetail.order.order_message
                                            .send_for_repair
                                     = $event)),
                            placeholder: "请输入",
                            onChange: _cache[52] || (_cache[52] = ($event: any) => (
                                        _ctx.editReceivingCar(
                                            $event,
                                            3,
                                            'send_for_repair'
                                        )
                                    ))
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "手机号码" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            disabled: _ctx.orderstatus>3,
                            class: "detail-input",
                            modelValue: 
                                        _ctx.orderDetail.order.order_message.phone
                                    ,
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (
                                        _ctx.orderDetail.order.order_message.phone
                                     = $event)),
                            onChange: _cache[54] || (_cache[54] = ($event: any) => (
                                        _ctx.editReceivingCar($event, 3, 'phone')
                                    )),
                            placeholder: "请输入"
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "合作方" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            class: "detail-input",
                            disabled: _ctx.orderstatus>3,
                            modelValue: 
                                        _ctx.orderDetail.order.order_message
                                            .partner_id
                                    ,
                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (
                                        _ctx.orderDetail.order.order_message
                                            .partner_id
                                     = $event)),
                            placeholder: "请选择",
                            onChange: _cache[56] || (_cache[56] = ($event: any) => (
                                        _ctx.editReceivingCar(
                                            $event,
                                            3,
                                            'partner_id'
                                        )
                                    ))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.partner_data, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.name,
                                  value: item.id,
                                  key: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "保险公司" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            class: "detail-input",
                            disabled: _ctx.orderstatus>3,
                            modelValue: 
                                        _ctx.orderDetail.order.order_message
                                            .insurance_company_id
                                    ,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (
                                        _ctx.orderDetail.order.order_message
                                            .insurance_company_id
                                     = $event)),
                            placeholder: "请选择",
                            onChange: _cache[58] || (_cache[58] = ($event: any) => (
                                        _ctx.editReceivingCar(
                                            $event,
                                            3,
                                            'insurance_company_id'
                                        )
                                    ))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.name,
                                  value: item.id,
                                  key: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "接车人" }, {
                        default: _withId(() => [
                          _createVNode("div", {
                            class: "message-form-button detail-input",
                            onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.choiceSalesman(false)))
                          }, [
                            _createVNode("p", {
                              class: {
                                            'c-99': !_ctx.orderDetail.order
                                                .order_message.meet_vehicle,
                                        }
                            }, _toDisplayString(_ctx.orderDetail.order.order_message
                                                .meet_vehicle || "请选择"), 3)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "施工人" }, {
                        default: _withId(() => [
                          _createVNode("div", {
                            class: "message-form-button detail-input",
                            onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.choiceBuilders(false)))
                          }, [
                            _createVNode("p", {
                              class: {
                                            'c-99': !_ctx.orderDetail.order
                                                .order_message
                                                .constructors_id_name,
                                        }
                            }, _toDisplayString(_ctx.orderDetail.order.order_message
                                                .constructors_id_name ||
                                            "请选择"), 3)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "推荐人" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.orderDetail.order.order_message
                                            .recommend_id,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.orderDetail.order.order_message
                                            .recommend_id = $event)),
                            placeholder: "请选择",
                            disabled: _ctx.orderstatus>3,
                            onChange: _cache[62] || (_cache[62] = ($event: any) => (
                                        _ctx.editReceivingCar(
                                            _ctx.orderDetail.order.order_message
                                            .recommend_id,
                                            3,
                                            'recommend_id'
                                        )
                                    ))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.nickname,
                                  value: item.id,
                                  key: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "检车分组" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.orderDetail.order.order_message
                                            .car_check_id,
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.orderDetail.order.order_message
                                            .car_check_id = $event)),
                            placeholder: "请选择",
                            disabled: _ctx.orderstatus>3,
                            onChange: _cache[64] || (_cache[64] = ($event: any) => (
                                        _ctx.editReceivingCar(
                                            _ctx.orderDetail.order.order_message
                                            .car_check_id,
                                            3,
                                            'car_check_id'
                                        )
                                    ))
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_check_group, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.name,
                                  value: item.id,
                                  key: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "工单备注",
                        prop: "settlement_notes"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            class: "detail-input",
                            disabled: _ctx.orderstatus>3,
                            modelValue: 
                                    _ctx.orderDetail.order.order_message
                                        .settlement_notes
                                ,
                            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (
                                    _ctx.orderDetail.order.order_message
                                        .settlement_notes
                                 = $event)),
                            placeholder: "请输入工单结算",
                            onChange: _cache[66] || (_cache[66] = ($event: any) => (
                                    _ctx.editReceivingCar($event, 3, 'settlement_notes')
                                ))
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ])
              ], 512), [
                [_directive_loading, _ctx.orderDetailLoading[0]],
                [_vShow, _ctx.orderNavIndex == 3]
              ]),
              _withDirectives(_createVNode("div", _hoisted_19, [
                (_ctx.orderDetail.is_user==0)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                      (_ctx.orderDetail.is_user==0)
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            model: _ctx.orderDetail,
                            "status-icon": "",
                            rules: _ctx.rules,
                            ref: "formRef",
                            "label-position": "left",
                            "label-width": "100px",
                            class: "mar-b-20 check"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, {
                                label: "会员号：",
                                prop: "check"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    class: "detail-input mar-r-18 mar-b-16",
                                    modelValue: _ctx.orderDetail.user_id,
                                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.orderDetail.user_id = $event)),
                                    placeholder: "请输入会员号"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_el_button, {
                                    class: "bg-red",
                                    onClick: _ctx.bindingUser
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_21
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"]))
                        : _createCommentVNode("", true),
                      (!_ctx.orderDetail.user_id)
                        ? (_openBlock(), _createBlock("p", _hoisted_22, " 当前车辆暂时未与任何会员号绑定！ "))
                        : _createCommentVNode("", true),
                      (_ctx.orderDetail.is_user==0)
                        ? (_openBlock(), _createBlock("p", _hoisted_23, " 温馨提示： 绑定后用户端才会生成订单 "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.orderDetail.is_user==1)
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, [
                        _createVNode(_component_el_input, {
                          class: "width-200",
                          modelValue: _ctx.bindUserId,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => (_ctx.bindUserId = $event)),
                          placeholder: "使用其他会员卡"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          class: "mar-l-12",
                          onClick: _ctx.changeOrderUser
                        }, {
                          default: _withId(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("label", null, _toDisplayString(_ctx.orderDetail.user_id), 1)
                      ]),
                      _createVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode("label", null, "★（LV" + _toDisplayString(_ctx.orderDetail.user_level) + "）", 1)
                      ]),
                      _createVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode("label", null, _toDisplayString(_ctx.orderDetail.user_bean), 1)
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode("label", null, _toDisplayString(_ctx.orderDetail.user_balance), 1)
                      ]),
                      _createVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode("label", null, _toDisplayString(_ctx.orderDetail.user_vip) + "次", 1)
                      ]),
                      _createVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createVNode("label", null, _toDisplayString(_ctx.orderDetail.user_coupon) + "张", 1)
                      ]),
                      _hoisted_39
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.orderDetail.is_user==2)
                  ? (_openBlock(), _createBlock("div", _hoisted_40, [
                      _createVNode("div", _hoisted_41, [
                        _createVNode("div", _hoisted_42, "已提交绑定到会员号" + _toDisplayString(_ctx.orderDetail.user_id) + "，等待车主验证通过", 1),
                        _createVNode(_component_el_button, {
                          class: "",
                          onClick: _ctx.unBindUser
                        }, {
                          default: _withId(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      (_ctx.orderDetail.is_user==2)
                        ? (_openBlock(), _createBlock("p", _hoisted_44, " 温馨提示： 需车主登录会员端“我的车辆”模块进行验证通过。 "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_directive_loading, _ctx.orderDetailLoading[2]],
                [_vShow, _ctx.orderNavIndex == 4]
              ]),
              _withDirectives(_createVNode("div", _hoisted_45, [
                _createVNode("div", null, [
                  _createVNode(_component_el_form, {
                    "label-position": "left",
                    "label-width": "100px"
                  }, {
                    default: _withId(() => [
                      (_ctx.orderDetail.coupon_text)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "优惠券："
                          }, {
                            default: _withId(() => [
                              _createVNode("p", _hoisted_46, _toDisplayString(_ctx.orderDetail.coupon_text), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, { label: "支付方式：" }, {
                        default: _withId(() => [
                          _createVNode("p", _hoisted_47, _toDisplayString(_ctx.orderDetail.pay_type), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "付款时间：" }, {
                        default: _withId(() => [
                          _createVNode("p", _hoisted_48, _toDisplayString(_ctx.orderDetail.pay_time), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "实付款：" }, {
                        default: _withId(() => [
                          _createVNode("p", _hoisted_49, _toDisplayString(_ctx.orderDetail.payment), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_directive_loading, _ctx.orderDetailLoading[1]],
                [_vShow, _ctx.orderNavIndex == 5]
              ])
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode("p", null, [
                _hoisted_51,
                _createVNode("span", _hoisted_52, "¥" + _toDisplayString(_ctx.orderDetail.project_offer_price), 1),
                _hoisted_53,
                _createVNode("span", _hoisted_54, "¥" + _toDisplayString(_ctx.orderDetail.mountings_offer_price), 1),
                _hoisted_55,
                _createVNode("span", _hoisted_56, "¥" + _toDisplayString(_ctx.orderDetail.order_offer_price), 1)
              ]),
              _createVNode(_component_el_button, {
                class: "bg-red",
                onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.$router.back(-1)))
              }, {
                default: _withId(() => [
                  _hoisted_57
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        center: "",
        title: "添加维修项目",
        modelValue: _ctx.serviceDialog,
        "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_ctx.serviceDialog = $event)),
        width: "800"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_58, [
            _createVNode("div", _hoisted_59, [
              _createVNode("p", {
                class: ["mar-r-20", { 'nav-range c-red': _ctx.dialogNavIndex == 0 }],
                onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.dialogNavIndex = 0))
              }, " 选择项目 ", 2),
              _createVNode("p", {
                class: ["mar-r-20", { 'nav-range c-red': _ctx.dialogNavIndex == 1 }],
                onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.dialogNavIndex = 1))
              }, " 临时项目 ", 2),
              _createVNode("p", {
                class: ["mar-r-20", { 'nav-range c-red': _ctx.dialogNavIndex == 2 }],
                onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.dialogNavIndex = 2))
              }, " 已购项目 ", 2),
              _createVNode("p", {
                onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.dialogNavIndex = 3)),
                class: { 'nav-range c-red': _ctx.dialogNavIndex == 3 }
              }, " 尊享卡套餐 ", 2)
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode("div", _hoisted_60, [
                _createVNode(_component_el_select, {
                  class: "mar-r-18 dialog-select",
                  modelValue: _ctx.dialogSelect.project_type_pid,
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => (_ctx.dialogSelect.project_type_pid = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  onChange: _cache[75] || (_cache[75] = ($event: any) => (
                                _ctx.dialogSelectChange($event, 'project_type_pid')
                            ))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  style: {"width":"202px"},
                  modelValue: _ctx.dialogSelect.search,
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_ctx.dialogSelect.search = $event)),
                  placeholder: "项目名称/拼音首字母",
                  clearable: "",
                  class: "mar-r-18",
                  "suffix-icon": "el-icon-search",
                  onChange: _cache[77] || (_cache[77] = ($event: any) => (_ctx.dialogSelectChange($event, 'search')))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _ctx.isAllChange
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_61, _toDisplayString(_ctx.is_all ? "确定" : "多选"), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_el_table, {
                data: _ctx.serviceTable,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                "highlight-current-row": _ctx.is_all,
                onCurrentChange: _ctx.handleCurrentChange,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withId(() => [
                  _hoisted_62,
                  (_ctx.is_all)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        type: "selection",
                        width: "55"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "name",
                    label: "项目名称",
                    "min-width": "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "item.name",
                    label: "工时费",
                    "min-width": "200"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("span", _hoisted_63, "¥" + _toDisplayString(scope.row["low_price"]) + "/", 1),
                      _createVNode("span", _hoisted_64, "¥" + _toDisplayString(scope.row["middle_price"]) + "/", 1),
                      _createVNode("span", _hoisted_65, "¥" + _toDisplayString(scope.row["high_price"]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange", "onSelectionChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 0]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_form, {
                "label-width": "100px",
                model: _ctx.serviceForm,
                rules: _ctx.serviceRules,
                ref: "serviceFormNode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "维修项目",
                    prop: "name"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.serviceForm.name,
                        "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.serviceForm.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "工时费",
                    prop: "price"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.serviceForm.price,
                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.serviceForm.price = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "返现方案",
                    prop: "return_cash_plan"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.serviceForm.return_cash_plan,
                        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_ctx.serviceForm.return_cash_plan = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createVNode("div", _hoisted_66, [
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.addService(true)))
                }, {
                  default: _withId(() => [
                    _hoisted_67
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.serviceDialog = false))
                }, {
                  default: _withId(() => [
                    _hoisted_68
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 1]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_table, {
                data: _ctx.userPackage,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                "highlight-current-row": _ctx.is_all,
                onCurrentChange: _ctx.myPackageSelect
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "project_name",
                    label: "项目名称",
                    "min-width": "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "item.name",
                    label: "工时费",
                    "min-width": "200"
                  }, {
                    default: _withId((scope) => [
                      _createVNode("span", _hoisted_69, "¥" + _toDisplayString(scope.row["low_price"]) + "/", 1),
                      _createVNode("span", _hoisted_70, "¥" + _toDisplayString(scope.row["middle_price"]) + "/", 1),
                      _createVNode("span", _hoisted_71, "¥" + _toDisplayString(scope.row["high_price"]), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "number",
                    label: "剩余次数",
                    "min-width": "200"
                  })
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 2]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_table, {
                data: _ctx.userVipCards,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                "highlight-current-row": _ctx.is_all,
                onCurrentChange: _ctx.myVipPackageSelect
              }, {
                default: _withId(() => [
                  _hoisted_72,
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "name",
                    label: "项目名称",
                    "min-width": "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "fee",
                    label: "工时费",
                    "min-width": "200"
                  }),
                  _createVNode(_component_el_table_column, {
                    align: "center",
                    prop: "number",
                    label: "剩余次数",
                    "min-width": "200"
                  })
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 3]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        center: "",
        title: "添加配件",
        modelValue: _ctx.partsDialog,
        "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (_ctx.partsDialog = $event)),
        width: 900
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_73, [
            _createVNode("div", _hoisted_74, [
              _createVNode("p", {
                class: ["mar-r-20", { 'nav-range c-red': _ctx.dialogNavIndex == 0 }],
                onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.dialogNavIndex = 0))
              }, " 选择配件 ", 2),
              _createVNode("p", {
                onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.dialogNavIndex = 1)),
                class: { 'nav-range c-red': _ctx.dialogNavIndex == 1 }
              }, " 临时配件 ", 2)
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode("div", _hoisted_75, [
                _createVNode(_component_el_select, {
                  class: "mar-r-18 dialog-select",
                  modelValue: _ctx.dialogSelect.mountings_type_pid,
                  "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_ctx.dialogSelect.mountings_type_pid = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  onChange: _cache[87] || (_cache[87] = ($event: any) => (
                                _ctx.dialogSelectChange($event, 'mountings_type_pid')
                            ))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_type_p_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  class: "mar-r-18 dialog-select",
                  modelValue: _ctx.dialogSelect.mountings_type_id,
                  "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_ctx.dialogSelect.mountings_type_id = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  onChange: _cache[89] || (_cache[89] = ($event: any) => (
                                _ctx.dialogSelectChange($event, 'mountings_type_id')
                            ))
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_type_data, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.id,
                        key: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  style: {"width":"202px"},
                  modelValue: _ctx.dialogSelect.search,
                  "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (_ctx.dialogSelect.search = $event)),
                  placeholder: "项目名称/拼音首字母",
                  clearable: "",
                  class: "mar-r-18",
                  "suffix-icon": "el-icon-search",
                  onChange: _cache[91] || (_cache[91] = ($event: any) => (_ctx.dialogSelectChange($event, 'search')))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _ctx.isAllChange
                }, {
                  default: _withId(() => [
                    _createVNode("span", _hoisted_76, _toDisplayString(_ctx.is_all ? "确定" : "多选"), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_el_table, {
                data: _ctx.partsTable,
                stripe: "",
                style: {"width":"100%"},
                class: "table",
                "header-cell-style": _ctx.headClass,
                "highlight-current-row": _ctx.is_all,
                onCurrentChange: _ctx.handleCurrentChange,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withId(() => [
                  _hoisted_77,
                  (_ctx.is_all)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        type: "selection",
                        width: "55"
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      align: "center",
                      prop: item.prop,
                      label: item.label,
                      "min-width": item.width,
                      key: index
                    }, null, 8, ["prop", "label", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "header-cell-style", "highlight-current-row", "onCurrentChange", "onSelectionChange"])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 0]
            ]),
            _withDirectives(_createVNode("div", null, [
              _createVNode(_component_el_form, {
                "label-width": "100px",
                model: _ctx.partsForm,
                rules: _ctx.partsRules,
                ref: "partsFormNode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "配件名称",
                    prop: "name"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.name,
                        "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => (_ctx.partsForm.name = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "规格" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.specification,
                        "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (_ctx.partsForm.specification = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "编码" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.encoding,
                        "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (_ctx.partsForm.encoding = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "销售价",
                    prop: "price"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.partsForm.price,
                        "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => (_ctx.partsForm.price = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "单位" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.partsForm.unit_id,
                        "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (_ctx.partsForm.unit_id = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.mountings_unit_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "返现方案",
                    prop: "return_cash_plan"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        class: "mar-r-18",
                        modelValue: _ctx.partsForm.return_cash_plan,
                        "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => (_ctx.partsForm.return_cash_plan = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.reappearance_type_data, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.name,
                              value: item.id,
                              key: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createVNode("div", _hoisted_78, [
                _createVNode(_component_el_button, {
                  class: "bg-red",
                  onClick: _cache[98] || (_cache[98] = ($event: any) => (_ctx.addService(false)))
                }, {
                  default: _withId(() => [
                    _hoisted_79
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[99] || (_cache[99] = ($event: any) => (_ctx.partsDialog = false))
                }, {
                  default: _withId(() => [
                    _hoisted_80
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.dialogNavIndex == 1]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "选择销售人员",
        center: "",
        modelValue: _ctx.isChoiceSale,
        "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => (_ctx.isChoiceSale = $event)),
        width: 400
      }, {
        default: _withId(() => [
          _createVNode(_component_el_radio_group, {
            class: "radio-sale width-full",
            onChange: _ctx.saleChange
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "flex flexC",
                  key: item.id
                }, [
                  _createVNode(_component_el_radio, {
                    label: item.id
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item.nickname), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["onChange"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "选择施工人员/部门",
        center: "",
        modelValue: _ctx.isChoiceBuilders,
        "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => (_ctx.isChoiceBuilders = $event)),
        width: 400
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_81, [
            _createVNode("div", _hoisted_82, [
              _createVNode("p", {
                class: ["c-red w-500 mar-r-20", { 'nav-range': _ctx.buildersType == 1 }],
                onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.buildersType = 1))
              }, " 部门 ", 2),
              _createVNode("p", {
                class: ["c-red w-500", { 'nav-range': _ctx.buildersType == 2 }],
                onClick: _cache[103] || (_cache[103] = ($event: any) => (_ctx.buildersType = 2))
              }, " 个人 ", 2)
            ]),
            _createVNode(_component_el_button, {
              class: "bg-red",
              onClick: _ctx.buildersChange
            }, {
              default: _withId(() => [
                _hoisted_83
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode(_component_el_checkbox_group, {
              class: "radio-sale width-full",
              modelValue: _ctx.buildersList,
              "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => (_ctx.buildersList = $event)),
              max: "1"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.branch_data, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "flex flexC",
                    key: item.id
                  }, [
                    _createVNode(_component_el_checkbox, {
                      label: item.id
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, _ctx.buildersType == 1]
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode(_component_el_checkbox_group, {
              class: "radio-sale width-full",
              modelValue: _ctx.buildersList,
              "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => (_ctx.buildersList = $event))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "flex flexC",
                    key: item.id
                  }, [
                    _createVNode(_component_el_checkbox, {
                      label: item.id
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(item.nickname), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, _ctx.buildersType == 2]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "选择历史报价",
        center: "",
        modelValue: _ctx.historDialog,
        "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => (_ctx.historDialog = $event)),
        width: 800
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_84, [
            _createVNode("div", _hoisted_85, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.historDialogNav, (name, index) => {
                return (_openBlock(), _createBlock("p", {
                  key: name,
                  class: ["mar-r-20", {
                            'nav-range c-red': _ctx.historDialogNavIndex == index,
                        }],
                  onClick: ($event: any) => (_ctx.historyChangeClick(index))
                }, _toDisplayString(name), 11, ["onClick"]))
              }), 128))
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.historDialogNav, (name, index) => {
              return _withDirectives((_openBlock(), _createBlock("div", { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.historDialogData.data, (item) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "flex flexSb histor-list mar-b-16",
                    key: item.id
                  }, [
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_86, "¥" + _toDisplayString(item.quoted_price), 1),
                      _createVNode("span", _hoisted_87, _toDisplayString(item.create_date), 1),
                      _createVNode("span", null, _toDisplayString(item.car_code), 1),
                      _createVNode("span", null, _toDisplayString(item.car_series), 1)
                    ]),
                    _createVNode(_component_el_button, {
                      class: "bg-red",
                      onClick: ($event: any) => (_ctx.historPriceChange(item))
                    }, {
                      default: _withId(() => [
                        _hoisted_88
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ], 512)), [
                [_vShow, index == _ctx.historDialogNavIndex]
              ])
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "新增工单",
        modelValue: _ctx.addDialogVisible,
        "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => (_ctx.addDialogVisible = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_89, [
            _hoisted_90,
            _createVNode("div", {
              class: "car-city mar-r-8 relative",
              onClick: _cache[109] || (_cache[109] = _withModifiers(($event: any) => (_ctx.citySelect = true), ["stop"]))
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.carCity), 1),
              _hoisted_91,
              _withDirectives(_createVNode("div", _hoisted_92, [
                _createVNode("div", _hoisted_93, [
                  _createVNode("span", null, _toDisplayString(_ctx.provinceText ? "选择车牌所属城市" : "选择车牌所属省份"), 1),
                  _createVNode("div", _hoisted_94, [
                    (_ctx.provinceText)
                      ? (_openBlock(), _createBlock("p", _hoisted_95, _toDisplayString(_ctx.provinceText), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      class: "close-icon relative",
                      onClick: _cache[108] || (_cache[108] = _withModifiers(($event: any) => (_ctx.citySelect = false), ["stop"]))
                    })
                  ])
                ]),
                (!_ctx.provinceText)
                  ? (_openBlock(), _createBlock("div", _hoisted_96, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinceList, (item) => {
                        return (_openBlock(), _createBlock("p", {
                          class: "select-city-text mar-b-10 mar-r-8 text-center",
                          key: item,
                          onClick: ($event: any) => (_ctx.provinceText = item)
                        }, _toDisplayString(item), 9, ["onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_97, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList('ABCDEFGHIJKLNMOPQRSTOVWXYZ', (item) => {
                        return _createVNode("p", {
                          class: "select-city-text mar-b-10 mar-r-8 text-center",
                          key: item,
                          onClick: _withModifiers(($event: any) => (_ctx.setCarCity(item)), ["stop"])
                        }, _toDisplayString(item), 9, ["onClick"])
                      }), 64))
                    ]))
              ], 512), [
                [_vShow, _ctx.citySelect]
              ])
            ]),
            _createVNode(_component_el_input, {
              style: {"width":"80px"},
              modelValue: _ctx.orderCarCode,
              "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => (_ctx.orderCarCode = $event)),
              onInput: _ctx._dialogCarcode
            }, null, 8, ["modelValue", "onInput"]),
            _createVNode(_component_el_checkbox, { class: "mar-l-8" }, {
              default: _withId(() => [
                _hoisted_98
              ]),
              _: 1
            })
          ]),
          (_ctx.form_status == 1)
            ? (_openBlock(), _createBlock("div", _hoisted_99, [
                (_ctx.carList.order_count > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_100, [
                      _createVNode("div", _hoisted_101, _toDisplayString(_ctx.form_carcode) + " 还有 " + _toDisplayString(_ctx.carList.order_count) + " 条未结算工单", 1),
                      _hoisted_102
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.carList.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_103, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carList, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: item,
                          onClick: ($event: any) => (_ctx._form_addcar(index)),
                          class: "flex flexC alignC bg-f2 add-car mar-t-12"
                        }, [
                          _createVNode("div", _hoisted_104, _toDisplayString(item.code) + " | " + _toDisplayString(item.model_name) + " | " + _toDisplayString(_ctx.form.vin) + " | 会员号:" + _toDisplayString(item.model_name), 1)
                        ], 8, ["onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_105, [
                      _hoisted_106,
                      _createVNode("div", {
                        class: "c-red mar-r-8 w-500",
                        onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx._form_addcar(null)))
                      }, "添加车辆")
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.form_status == 2 || _ctx.form_status == 3)
            ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_107, [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: _ctx.form,
                  rules: _ctx.form_rules,
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.form_carcode), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      prop: "service_type_id",
                      label: "服务类型"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.service_type_id,
                          "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => (_ctx.form.service_type_id = $event)),
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.basicset_name,
                                value: item.basicset_id,
                                key: item.basicset_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.form_status == 2)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "VIN"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.form.vin,
                              "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => (_ctx.form.vin = $event)),
                              placeholder: "请输入VIN"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form_status == 3)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          label: "VIN"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", null, _toDisplayString(_ctx.carList[_ctx.form_itemindex].vin), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form_status == 2)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 2,
                          label: "品牌车型",
                          required: ""
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_col, { span: 11 }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { prop: "car_brand_id" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      class: "mar-r-8",
                                      modelValue: _ctx.form.car_brand_id,
                                      "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => (_ctx.form.car_brand_id = $event)),
                                      style: {"width":"108px"},
                                      clearable: "",
                                      filterable: "",
                                      placeholder: "请选择",
                                      onChange: _cache[115] || (_cache[115] = ($event: any) => (_ctx.selectChange($event, 'car_brand_id_a')))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_brand_data, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.brand_name,
                                            value: item.id,
                                            key: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 11 }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { prop: "car_series_id" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      class: "mar-r-18",
                                      modelValue: _ctx.form.car_series_id,
                                      "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event: any) => (_ctx.form.car_series_id = $event)),
                                      placeholder: "请选择",
                                      style: {"width":"132px"},
                                      disabled: !_ctx.form.car_brand_id
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_series_data_a, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.series_name,
                                            value: item.id,
                                            key: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.form_status == 3)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 3,
                          label: "品牌车型"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", null, _toDisplayString(_ctx.carList[_ctx.form_itemindex].series_name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, { label: "所属单位" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.units_id,
                          "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => (_ctx.form.units_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_option, {
                              label: "区域一",
                              value: "shanghai"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "送修人" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.send_for_repair,
                          "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => (_ctx.form.send_for_repair = $event)),
                          placeholder: "请输入送修人"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "送修人手机" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.phone,
                          "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => (_ctx.form.phone = $event)),
                          placeholder: "请输入"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "合作方" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.partner_id,
                          "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => (_ctx.form.partner_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.partner_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.basicset_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "保险公司" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.insurance_company_id,
                          "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => (_ctx.form.insurance_company_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.insurance_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: item.id,
                                key: item.basicset_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "进厂里程" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.mitplant,
                          "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => (_ctx.form.mitplant = $event)),
                          placeholder: "请输入进厂里程"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "接车人",
                      prop: "meet_vehicle_id"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.form.meet_vehicle_id,
                          "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => (_ctx.form.meet_vehicle_id = $event)),
                          class: "width-86",
                          placeholder: "请选择"
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.receive_data, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.nickname,
                                value: item.id,
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "施工人" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_cascader, {
                          clearable: "",
                          options: _ctx.constructors_data,
                          props: {
                        expandTrigger: 'hover',
                        label: 'name',
                        value: 'id',
                    },
                          placeholder: "选择施工人",
                          onChange: _cache[124] || (_cache[124] = ($event: any) => (_ctx.constructorChange($event)))
                        }, null, 8, ["options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          class: "bg-red",
                          onClick: _ctx._onSubmit
                        }, {
                          default: _withId(() => [
                            _hoisted_108
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          onClick: _cache[125] || (_cache[125] = ($event: any) => (_ctx.form_status = 0))
                        }, {
                          default: _withId(() => [
                            _hoisted_109
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ], 512)), [
                [_directive_loading, _ctx.form_isload]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        title: "更换车辆",
        modelValue: _ctx.changeCarData.changeDialogVisible,
        "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => (_ctx.changeCarData.changeDialogVisible = $event)),
        center: "",
        width: 1000
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_110, [
            _createVNode("div", null, "原车辆：" + _toDisplayString(_ctx.orderDetail.code), 1),
            _createVNode("div", _hoisted_111, "VIN：" + _toDisplayString(_ctx.orderDetail?.vin), 1),
            _createVNode("div", _hoisted_112, "品牌车型：" + _toDisplayString(_ctx.orderDetail?.category_name), 1)
          ]),
          _createVNode("div", _hoisted_113, [
            _hoisted_114,
            _createVNode("div", {
              class: "car-city mar-r-8 relative",
              onClick: _cache[128] || (_cache[128] = _withModifiers(($event: any) => (_ctx.changeCarData.citySelect = true), ["stop"]))
            }, [
              _createVNode("span", null, _toDisplayString(_ctx.changeCarData.carCity), 1),
              _hoisted_115,
              _withDirectives(_createVNode("div", _hoisted_116, [
                _createVNode("div", _hoisted_117, [
                  _createVNode("span", null, _toDisplayString(_ctx.changeCarData.provinceText ? "选择车牌所属城市" : "选择车牌所属省份"), 1),
                  _createVNode("div", _hoisted_118, [
                    (_ctx.changeCarData.provinceText)
                      ? (_openBlock(), _createBlock("p", _hoisted_119, _toDisplayString(_ctx.changeCarData.provinceText), 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      class: "close-icon relative",
                      onClick: _cache[127] || (_cache[127] = _withModifiers(($event: any) => (_ctx.changeCarData.citySelect = false), ["stop"]))
                    })
                  ])
                ]),
                (!_ctx.changeCarData.provinceText)
                  ? (_openBlock(), _createBlock("div", _hoisted_120, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.changeCarData.provinceList, (item) => {
                        return (_openBlock(), _createBlock("p", {
                          class: "select-city-text mar-b-10 mar-r-8 text-center",
                          key: item,
                          onClick: ($event: any) => (_ctx.changeCarData.provinceText = item)
                        }, _toDisplayString(item), 9, ["onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_121, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList('ABCDEFGHIJKLNMOPQRSTOVWXYZ', (item) => {
                        return _createVNode("p", {
                          class: "select-city-text mar-b-10 mar-r-8 text-center",
                          key: item,
                          onClick: _withModifiers(($event: any) => (_ctx.setCarCity(item)), ["stop"])
                        }, _toDisplayString(item), 9, ["onClick"])
                      }), 64))
                    ]))
              ], 512), [
                [_vShow, _ctx.changeCarData.citySelect]
              ])
            ]),
            _createVNode(_component_el_input, {
              style: {"width":"80px"},
              modelValue: _ctx.changeCarData.orderCarCode,
              "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => (_ctx.changeCarData.orderCarCode = $event)),
              onInput: _ctx._dialogCarcode
            }, null, 8, ["modelValue", "onInput"])
          ]),
          (_ctx.changeCarData.form_status == 1)
            ? (_openBlock(), _createBlock("div", _hoisted_122, [
                (_ctx.changeCarData.carList.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_123, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.changeCarData.carList, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: item,
                          onClick: ($event: any) => (_ctx._form_addcar(index)),
                          class: "flex flexC alignC bg-f2 add-car mar-t-12"
                        }, [
                          _createVNode("div", _hoisted_124, _toDisplayString(item.code) + " | " + _toDisplayString(item.model_name) + " | 会员号:" + _toDisplayString(item.user_text), 1)
                        ], 8, ["onClick"]))
                      }), 128)),
                      _createVNode("div", _hoisted_125, [
                        _hoisted_126,
                        _createVNode("div", {
                          class: "c-red mar-r-8 w-500",
                          onClick: _cache[130] || (_cache[130] = ($event: any) => (_ctx._form_addcar(null)))
                        }, "添加车辆")
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_127, [
                      _hoisted_128,
                      _createVNode("div", {
                        class: "c-red mar-r-8 w-500",
                        onClick: _cache[131] || (_cache[131] = ($event: any) => (_ctx._form_addcar(null)))
                      }, "添加车辆")
                    ]))
              ]))
            : _createCommentVNode("", true),
          (_ctx.changeCarData.form_status == 2 || _ctx.changeCarData.form_status == 3)
            ? (_openBlock(), _createBlock("div", _hoisted_129, [
                _createVNode(_component_el_form, {
                  ref: "changeCarData.formRef",
                  model: _ctx.changeCarData.form,
                  rules: _ctx.changeCarData.form_rules,
                  "label-width": "100px"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.changeCarData.form.car_code), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.changeCarData.form_status == 2)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "VIN"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.changeCarData.form.vin,
                              "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => (_ctx.changeCarData.form.vin = $event)),
                              placeholder: "请输入VIN"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.changeCarData.form_status == 3)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          label: "VIN"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", null, _toDisplayString(_ctx.changeCarData.carList[_ctx.changeCarData.form_itemindex].vin), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.changeCarData.form_status == 2)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 2,
                          label: "品牌车型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_col, { span: 11 }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { prop: "car_brand_id" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      class: "mar-r-8",
                                      modelValue: _ctx.changeCarData.form.car_brand_id,
                                      "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => (_ctx.changeCarData.form.car_brand_id = $event)),
                                      style: {"width":"108px"},
                                      clearable: "",
                                      filterable: "",
                                      placeholder: "请选择",
                                      onChange: _cache[134] || (_cache[134] = ($event: any) => (_ctx.changeCarDataCarBrandChange($event, 'car_brand_id_a')))
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.car_brand_data, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.brand_name,
                                            value: item.id,
                                            key: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 11 }, {
                              default: _withId(() => [
                                _createVNode(_component_el_form_item, { prop: "car_series_id" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      class: "mar-r-18",
                                      modelValue: _ctx.changeCarData.form.car_series_id,
                                      "onUpdate:modelValue": _cache[135] || (_cache[135] = ($event: any) => (_ctx.changeCarData.form.car_series_id = $event)),
                                      placeholder: "请选择",
                                      style: {"width":"132px"},
                                      disabled: !_ctx.changeCarData.form.car_brand_id
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.changeCarData.car_series_data_a, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            label: item.series_name,
                                            value: item.id,
                                            key: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.changeCarData.form_status == 3)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 3,
                          label: "品牌车型"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", null, _toDisplayString(_ctx.changeCarData.carList[_ctx.changeCarData.form_itemindex].series_name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.changeCarData.form_status == 2)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 4,
                          label: "所属单位"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.changeCarData.form.units_id,
                              "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => (_ctx.changeCarData.form.units_id = $event)),
                              class: "width-86",
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.repairunit_data, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.repair_unit_name,
                                    value: item.repair_unit_id,
                                    key: item.repair_unit_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.changeCarData.form_status == 3)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 5,
                          label: "所属单位"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", null, _toDisplayString(_ctx.changeCarData.carList[_ctx.changeCarData.form_itemindex].repair_unit_name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          class: "bg-red",
                          onClick: _ctx.carChangeSubmit
                        }, {
                          default: _withId(() => [
                            _hoisted_130
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          onClick: _cache[137] || (_cache[137] = ($event: any) => (_ctx.changeCarData.changeDialogVisible = false))
                        }, {
                          default: _withId(() => [
                            _hoisted_131
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 4),
    _withDirectives(_createVNode(_component_PrintForm, { id: "print" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_132, [
          _createVNode("div", _hoisted_133, [
            _hoisted_134,
            _createVNode("div", _hoisted_135, _toDisplayString(_ctx.userInfo.store_name), 1),
            _hoisted_136
          ]),
          _createVNode("div", _hoisted_137, [
            _createVNode("div", _hoisted_138, [
              _createVNode("div", _hoisted_139, " 单据编号：" + _toDisplayString(_ctx.orderDetail.ordersn), 1),
              _createVNode("div", _hoisted_140, _toDisplayString(_ctx.orderDetail.create_time_text), 1)
            ]),
            _createVNode("table", _hoisted_141, [
              _createVNode("tbody", null, [
                _createVNode("tr", null, [
                  _hoisted_142,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.code), 1),
                  _hoisted_143,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.category_name), 1),
                  _hoisted_144,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.vin), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_145,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.order_message?.send_for_repair), 1),
                  _hoisted_146,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.order_message?.phone), 1),
                  _hoisted_147,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.basicset_id_name), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_148,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.create_time_text), 1),
                  _hoisted_149,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.order?.order_message?.mitplant), 1),
                  _hoisted_150,
                  _createVNode("th", null, _toDisplayString(_ctx.orderDetail?.meet_vehicle), 1)
                ])
              ])
            ]),
            (_ctx.isProject)
              ? (_openBlock(), _createBlock("table", _hoisted_151, [
                  _hoisted_152,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.offer[0], (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index + 1), 1),
                        _createVNode("th", null, _toDisplayString(item.project_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _hoisted_153,
                      _createVNode("th", _hoisted_154, "维修工时费小计：￥" + _toDisplayString(_ctx.orderDetail.project_sum_quoted_price), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isMountings)
              ? (_openBlock(), _createBlock("table", _hoisted_155, [
                  _hoisted_156,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderDetail.offer[1], (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("th", null, _toDisplayString(index + 1), 1),
                        _createVNode("th", null, _toDisplayString(item.mountings_name), 1),
                        _createVNode("th", null, _toDisplayString(item.num), 1),
                        _createVNode("th", null, _toDisplayString(item.quoted_price), 1),
                        _createVNode("th", null, _toDisplayString(item.price), 1)
                      ]))
                    }), 128)),
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_157, "配件费用小计：￥" + _toDisplayString(_ctx.orderDetail.mountings_sum_quoted_price), 1)
                    ]),
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_158, "报价金额：￥" + _toDisplayString(_ctx.orderDetail.order_offer_price), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_159, [
              _createVNode("div", _hoisted_160, [
                _createVNode("div", _hoisted_161, " 客　户：" + _toDisplayString(_ctx.orderDetail?.order_message?.send_for_repair), 1),
                _createVNode("div", _hoisted_162, " 接车员：" + _toDisplayString(_ctx.orderDetail?.meet_vehicle), 1)
              ]),
              (_ctx.qrcodeImgeUrl)
                ? (_openBlock(), _createBlock("div", _hoisted_163, [
                    _hoisted_164,
                    _hoisted_165
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_166, [
              _createVNode("div", _hoisted_167, " 地址：" + _toDisplayString(_ctx.orderDetail?.store_address), 1),
              _createVNode("div", _hoisted_168, " 电话：" + _toDisplayString(_ctx.orderDetail?.store_phone), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isPrint]
    ])
  ], 64))
})